import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../data/services/auth.service';
import { SelectUserSchoolService } from 'src/app/data/services/select-user-school.service';
import { SchoolDto } from 'src/app/data/models/dto/school.dto';

@Component({
  selector: 'app-select-school',
  templateUrl: './select-school.component.html',
  styleUrls: ['./select-school.component.scss']
})
export class SelectSchoolComponent implements OnInit {
  schools: SchoolDto[] = [];
  loading: boolean = false;

  constructor(
    private readonly selectSchoolService: SelectUserSchoolService,
    private readonly authService: AuthService,
    private readonly router: Router,
  ) { }

  async ngOnInit(): Promise<void> {
    const schools = this.selectSchoolService.getUserSchools();

    if (!schools || schools.length === 0) {
      await this.authService.logout();
      await this.router.navigate(['/login']);
      return;
    }

    this.schools = schools;
  }

  async selectSchool(school: SchoolDto): Promise<void> {
    try {
      this.loading = true;

      await this.selectSchoolService.selectUserSchool(school);

      await this.router.navigate(['news-list']).then(() => window.location.reload());
    } catch (error) {
      console.log('failed to select school', error);
    }
    finally {
      this.loading = false;
    }
  }
}
